import { Route } from "@angular/router";
import { Permissions } from "src/app/core/common";
import { RoutesConstants } from "src/app/shared/common";
import { PermissionGuard } from "src/app/shared/guard/permission-guard";

export const FATIHA_REQUESTS_ROUTES: Route[] = [
    {
        path: RoutesConstants.FATIHA_REQUESTS_PAGE_URL,
        loadComponent: () =>
            import('./pages/fatiha-request-page/fatiha-request-page.component').then((x) => x.FatihaRequestPageComponent),
        canActivate: [PermissionGuard],
        data: {
            permissions: [Permissions.Fatiha_Requests]
        }
    }
]